import _get from 'lodash/get';
import { featuresState } from 'features/selectors';

export const purchaseOrderManagementState = state =>
  _get(featuresState(state), 'purchaseOrderManagement');
